import classNames from 'classnames'
import { ChangeEvent, ReactNode, forwardRef, useMemo } from 'react'

export type SwapProps = {
  on: ReactNode
  off: ReactNode
  rotate?: boolean
  flip?: boolean
  // eslint-disable-next-line no-unused-vars
  onChange?: (checked: boolean) => void
  className?: string
}

export const Swap = forwardRef<HTMLLabelElement, SwapProps>(
  (
    { on, off, rotate = false, flip = false, onChange, className: classProps = '', ...props },
    ref,
  ) => {
    const className = useMemo(
      () =>
        classNames({
          swap: true,
          'swap-rotate': rotate,
          'swap-flip': flip,
          [classProps]: true,
        }),
      [rotate, flip, classProps],
    )

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      onChange?.(e.target.checked)
    }

    return (
      <label ref={ref} className={className} {...props}>
        <input type="checkbox" onChange={handleChange} />
        <div className="swap-on">{on}</div>
        <div className="swap-off">{off}</div>
      </label>
    )
  },
)

export default Swap
